import api from './api'
import type { CrudField } from './crudService'

export interface ColumnInfo {
  name: string
  data_type: string
  is_nullable: boolean
  column_default: any
  column_key?: string | null
  extra?: string | null
}

class DbMetadataService {
  async getTables(): Promise<string[]> {
    const res = await api.get('db/tables')
    return res.data.data || res.data || []
  }

  async getColumns(tableName: string): Promise<ColumnInfo[]> {
    const res = await api.get(`db/tables/${encodeURIComponent(tableName)}/columns`)
    return res.data.data || res.data || []
  }

  async getCrudFields(tableName: string): Promise<CrudField[]> {
    const res = await api.get(`db/tables/${encodeURIComponent(tableName)}/crud-fields`)
    const items: any[] = res.data.data || res.data || []
    // Normalizar por si backend no envía 'id'
    return items.map((f, idx) => ({
      id: f.id ?? `${tableName}-${f.name}-${idx}`,
      name: f.name,
      type: f.type as CrudField['type'],
      required: Boolean(f.required),
      max_length: typeof f.max_length === 'number' ? f.max_length : (f.max_length != null ? Number(f.max_length) : undefined),
      default_value: f.default_value,
      is_primary_key: Boolean(f.is_primary_key),
      is_searchable: f.is_searchable !== undefined ? Boolean(f.is_searchable) : true,
      show_in_list: f.show_in_list !== undefined ? Boolean(f.show_in_list) : true,
      select_options: Array.isArray(f.select_options) ? f.select_options : undefined,
      precision: f.precision != null ? Number(f.precision) : undefined,
      scale: f.scale != null ? Number(f.scale) : undefined,
    }))
  }
}

const dbMetadataService = new DbMetadataService()
export default dbMetadataService
